import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import { useUserPermissions } from "~context/UserPermissionsContext/index.js";
import { useGetLocationParams } from "~hooks/useGetLocationParams.js";

export const useFetchOrganizations = () => {
  const request = useApi();
  const { customerId } = useParams();

  return useQuery({
    queryKey: ["customer-organizations", customerId],
    queryFn: async () => {
      const result = await request("user/organizations");
      return result?.data || [];
    },
    staleTime: 5 * 60 * 1000,
  });
};

export const useFetchOrganization = () => {
  const request = useApi();
  const { organizationId, sport } = useGetLocationParams();
  const { hasOrganizationAccess } = useUserPermissions();

  return useQuery({
    enabled: !!organizationId && hasOrganizationAccess,
    queryKey: ["organization", sport, organizationId],
    queryFn: async () => {
      const result = await request(`${sport}/organizations/${organizationId}`);
      return result?.data?.[0] || null;
    },
    staleTime: 60 * 1000,
  });
};
